import { Redirect, Route, Switch, useLocation } from 'quartz-routing/react-router';
import { DEFAULT_ROUTE, Paths } from '../constants/Paths';
import { InvoicesPage } from '../containers/InvoicesPage';
import { InvoiceDetailsPage } from '../containers/InvoiceDetailsPage';
import { QuoteDetailsPage } from '../containers/QuoteDetailsPage';
import { PayInvoicePage } from '../containers/PayInvoicePage';
import { PaymentMethodsPage } from '../containers/PaymentMethodsPage';
import { QuotesPage } from '../containers/QuotesPage';
import { SubscriptionsPage } from '../containers/SubscriptionsPage';
import { PaymentHistoryPage } from '../containers/PaymentHistoryPage';
import { UpdatePaymentMethod } from '../containers/UpdatePaymentMethod';
import { PageErrorBoundary } from './PageErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Routes = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: Paths.INVOICE_DETAILS,
      exact: true,
      children: /*#__PURE__*/_jsx(PageErrorBoundary, {
        children: /*#__PURE__*/_jsx(InvoiceDetailsPage, {})
      }, location.pathname)
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.PAY_INVOICE,
      exact: true,
      children: /*#__PURE__*/_jsx(PageErrorBoundary, {
        children: /*#__PURE__*/_jsx(PayInvoicePage, {})
      }, location.pathname)
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.INVOICES,
      exact: true,
      children: /*#__PURE__*/_jsx(PageErrorBoundary, {
        children: /*#__PURE__*/_jsx(InvoicesPage, {})
      }, location.pathname)
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.QUOTE_DETAILS,
      exact: true,
      children: /*#__PURE__*/_jsx(PageErrorBoundary, {
        children: /*#__PURE__*/_jsx(QuoteDetailsPage, {})
      }, location.pathname)
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.QUOTES,
      exact: true,
      children: /*#__PURE__*/_jsx(PageErrorBoundary, {
        children: /*#__PURE__*/_jsx(QuotesPage, {})
      }, location.pathname)
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.SUBSCRIPTIONS,
      exact: true,
      children: /*#__PURE__*/_jsx(PageErrorBoundary, {
        children: /*#__PURE__*/_jsx(SubscriptionsPage, {})
      }, location.pathname)
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.PAYMENT_METHODS,
      exact: true,
      children: /*#__PURE__*/_jsx(PageErrorBoundary, {
        children: /*#__PURE__*/_jsx(PaymentMethodsPage, {})
      }, location.pathname)
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.PAYMENT_HISTORY,
      exact: true,
      children: /*#__PURE__*/_jsx(PageErrorBoundary, {
        children: /*#__PURE__*/_jsx(PaymentHistoryPage, {})
      }, location.pathname)
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.UPDATE_PAYMENT_METHOD,
      exact: true,
      children: /*#__PURE__*/_jsx(PageErrorBoundary, {
        children: /*#__PURE__*/_jsx(UpdatePaymentMethod, {})
      }, location.pathname)
    }), /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: DEFAULT_ROUTE,
        search: location.search,
        hash: location.hash
      }
    })]
  });
};